import React from 'react';
import mapContextToProps from 'react-context-toolbox/mapContextToProps';

import { ApiContext } from './ApiProvider';
import LoadingIndicator from './LoadingIndicator';
import ErrorSegment from './ErrorSegment';
import captureException from '../utils/captureException';

const propTypes = {};

class Query extends React.Component {
  state = { loading: false, data: null };

  componentDidMount() {
    this.execute();
  }

  componentDidUpdate(prevProps) {
    if (prevProps === this.props) return;
    this.execute();
  }

  execute() {
    const { client, variables, query } = this.props;
    const { fetched, loading } = this.state;

    if (fetched || loading || !client || !query) return;

    this.setState({ loading: true }, async () => {
      const resp = await client.execute(query, variables);
      let error = null;
      if (resp.errors) {
        error = new Error('GraphQL Error');
        error.details = resp.errors;
        captureException(error);
      }

      this.setState({
        error,
        fetched: true,
        loading: false,
        data: resp.data,
      });
    });
  }

  render() {
    const { children, showLoading, client, renderError } = this.props;
    const { fetched, data, error } = this.state;

    if (error) {
      return (renderError && renderError(error, client)) || <ErrorSegment />;
    }
    if (!fetched) return showLoading ? <LoadingIndicator /> : null;

    return React.isValidElement(children)
      ? React.cloneElement(children, data)
      : children(data, client);
  }
}

Query.propTypes = propTypes;

export default mapContextToProps(ApiContext, client => ({ client }), Query);
